import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { ManzanitaPresetListingProvider } from "./context/ManzanitaPresetListingProvider";
import { ManzanitaPresetListing } from "./ManzanitaPresetListing";

export const ManzanitaPresetListingPage: React.VFC = () => {
    return (
        <ManzanitaPresetListingProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <ManzanitaPresetListing />
        </ManzanitaPresetListingProvider>
    );
};
